import { css } from "styled-components";

export const lineTruncationStyle = (numberOfLines: number) => css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${numberOfLines};
  display: -webkit-box;
  overflow-wrap: break-word;
  overflow: clip;
  word-break: break-word;
`;
